<template>
  <v-card flat id="headerBarCustom">
    <v-toolbar
      style="background-color: #FFFFFF;"
      flat
      :class="{
        'custom-header-toolbar': !$vuetify.breakpoint.smAndDown,
        'mobile-toolbar-header': $vuetify.breakpoint.smAndDown
      }"
      fixed
      app
    >
      <div style="display: flex; width: 100%; align-items: center;">
        <!-- Logo -->
        <v-img
          :src="getLogoImage"
          alt="Pizza Depot Logo"
          contain
          :max-height="$vuetify.breakpoint.smAndDown ? '155' : '230'" 
          :max-width="$vuetify.breakpoint.smAndDown ? '155' : '230'" 
          :width="$vuetify.breakpoint.smAndDown ? '155' : '218'"
          style="cursor: pointer; "
          @click="goToStaticLink('https://pizzadepot.com/')"
          :class="{ 'mobile-margin': $vuetify.breakpoint.smAndDown, 'web-margin': !$vuetify.breakpoint.smAndDown }" 
        ></v-img>

        <v-spacer></v-spacer>

        <!-- Desktop Navigation Links -->
        <v-toolbar-items class="header-links" v-if="!$vuetify.breakpoint.smAndDown">
        <v-btn
          v-for="link in navLinks"
          :key="link.label"
          text
          class="header-link"
          :class="{ 'menu-item-highlight': link.highlight }"
          :ripple="false"
          @click="goToStaticLink(link.url)"
          color="black"
        >
          {{ link.label.toUpperCase() }}
        </v-btn>
        <v-menu offset-y open-on-hover :nudge-top="12" :close-on-content-click="true" transition="slide-y-transition">
          <template #activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" class="header-link" :ripple="false" color="black">
              {{ $vuetify.t('$vuetify.common.location') }}
              <v-icon color="black">keyboard_arrow_down</v-icon>
            </v-btn>
          </template>
          <v-list class="locations-dropdown-list">
            <v-list-item
              v-for="loc in locationLinks"
              :key="loc.label"
              link
              @click="goToStaticLink(loc.url)"
            >
              <v-list-item-title class="locations-dropdown-item-title">{{ loc.label }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>

        <!-- User Controls -->
        <v-toolbar-items v-if="$route.name !== 'group' && $route.name !== 'checkout'">
          <header-bar-menu v-if="isLoggedIn" />
          <v-icon 
            style="padding-right: 16px" 
            v-else-if="allowsGuest && !$vuetify.breakpoint.smAndDown" 
            @click="goToGuestHistory" 
            color="black"
          >list_alt</v-icon>

          <!-- Login/Signup Button -->
          <v-btn
            flat
            v-if="!isLoggedIn && !$store.getters['groupOrder/isGuestParticipant']"
            @click="openLogin"
            class="header-link login-signup-button"
            :ripple="false"
            color="black"
          >
            <v-icon>account_circle</v-icon>
            <span style="margin-left: 5px" v-if="!$vuetify.breakpoint.smAndDown">{{ $vuetify.t('$vuetify.common.login') }}</span>
          </v-btn>

          <!-- Cart Button -->
          <v-btn 
            flat 
            @click="toggleCart" 
            :style="!$vuetify.breakpoint.smAndDown ? 'margin-left: 10px !important' : ''" 
            class="header-link cart-button" 
            :ripple="false" 
            color="black"
          >
            <v-badge color="black" overlap>
              <span slot="badge" v-if="getNumCartItems > 0" class="badge-text">{{ getNumCartItems }}</span>
              <v-icon>shopping_cart</v-icon>
            </v-badge>
            <span style="margin-left: 3px" v-if="!$vuetify.breakpoint.smAndDown">Cart</span>
          </v-btn>
          
          <!-- Mobile Menu Button -->
          <v-btn
            v-if="$vuetify.breakpoint.smAndDown"
            icon
            @click="drawer = !drawer"
          >
            <v-icon>menu</v-icon>
          </v-btn>
        </v-toolbar-items>
      </div>
    </v-toolbar>
<v-navigation-drawer
  v-model="drawer"
  temporary
  right
  app
  height="100vh"
  class="mobile-drawer-fullscreen"
  style="background-color: white;"
>
  <div class="drawer-header">
    <v-btn icon @click="drawer = false" class="drawer-close-btn">
      <v-icon>close</v-icon>
    </v-btn>
  </div>
  
  <v-list class="drawer-list" nav>
    <v-list-item
      v-for="link in navLinks"
      :key="link.label"
      link
      @click="goToStaticLink(link.url)"
      :class="['mobile-nav-item', { 'menu-item-highlight': link.highlight, 'first-nav-item': link.label === 'About Us' }]"
    >
      <v-list-item-content>
        <v-list-item-title><strong>{{ link.label }}</strong></v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-group no-action class="mobile-nav-group mobile-nav-item">
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title><strong>Locations</strong></v-list-item-title>
        </v-list-item-content>
      </template>
      <v-list-item
        v-for="loc in locationLinks"
        :key="loc.label"
        link
        @click="goToStaticLink(loc.url)"
        class="mobile-nav-subitem"
      >
        <v-list-item-content>
          <v-list-item-title>{{ loc.label }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>
  </v-list>
</v-navigation-drawer>

    <!-- Cart Dialog -->
    <v-dialog
      v-model="cartDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      :width="$vuetify.breakpoint.mdAndUp ? 450 : '100%'"
      content-class="rounded-dialog cartDialogClass"
    >
      <v-card class="rounded-card">
        <div class="header-container">
          <h2 class="title-text">
            {{ getStore.name }}
          </h2>
          <v-btn icon class="close-btn" @click="cartDialog = false" :ripple="false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <cart @closeCart="cartDialog = false" />
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import Cart from '@/components/Cart.vue'
  import HeaderBarMenu from '@/components/HeaderBarMenu.vue'
  import { disableDocumentScrolling, enableDocumentScrolling } from '../services/util.service'

  export default {
    components: {
      Cart,
      HeaderBarMenu
    },

    data() {
      return {
        cartDialog: false,
        scrollTop: null,
        drawer: false,
        navLinks: [
          { label: 'Menu', url: 'https://pizzadepot.com/menu/' },
          { label: 'Deals', url: 'https://pizzadepot.com/specials/' },
          { label: 'Rewards', url: 'https://pizzadepot.com/rewards/' },
          { label: 'Franchise', url: 'https://pizzadepot.com/franchise/' },
        ],
        locationLinks: [
          { label: 'Edison – NJ', url: 'https://pizzadepot.com/locations/edison/' },
          { label: 'Austin – Texas', url: 'https://pizzadepot.com/locations/austin/' },
          { label: 'Hicksville – NY (Serves Halal Only) Coming Soon', url: 'https://pizzadepot.com/locations/hicksville/' },
          { label: 'Parsippany –  NJ (Coming Soon)', url: 'https://pizzadepot.com/locations/parsipanny/' },
        ],
      }
    },
    
    mounted() {
      this.$bus.$on('guestCheckoutSuccess', () => {
        this.cartDialog = false;
      });
      this.drawer = false;
    },
    
    beforeDestroy() {
      this.$bus.$off('guestCheckoutSuccess');
    },
    
    computed: {
      allowsGuest() {
        return !this.isLoggedIn && this.allowAnonymousDineIn && this.skipCheckout === true
      },
      
      getLogoImage() {
        const path = process.env.VUE_APP_API_IMAGE
        let relativePath = ''
        
        if (this.getStore && this.getStore.images && this.getStore.images.OWA_LOGO && 
            this.getStore.images.OWA_LOGO[0] && this.getStore.images.OWA_LOGO[0].url) {
          relativePath = this.getStore.images.OWA_LOGO[0].url
        } else if (this.getStore && this.getStore.images && this.getStore.images.LOGO && 
            this.getStore.images.LOGO[0] && this.getStore.images.LOGO[0].url) {
          relativePath = this.getStore.images.LOGO[0].url
        } else if (this.getGroup && this.getGroup.storeLogo) {
          relativePath = this.getGroup.storeLogo
        }
        return relativePath ? `${path}${relativePath}` : ''
      },
      
      ...mapGetters([
        'getStore',
        'getMenu',
        'getGroup',
        'isLoggedIn',
        'getNumCartItems',
        'skipCheckout',
        'allowAnonymousDineIn'
      ])
    },

    watch: {
      // DEV-11458: the cart is an overlay on the current page, so leaving the page -- the
      // browser's back/forward buttons included -- closes it, rather than leaving it open on
      // the next page (e.g. over checkout). Path only: query-only URL updates keep it open.
      '$route.path'() {
        this.cartDialog = false
      },
      cartDialog(newVal) {
        if (newVal) {
          this.$store.dispatch('fetchAiCartRecommendationsOnOpen')
          this.$store.dispatch('trackCartEvent', { event: 'view_cart' })
        }
        if (this.$vuetify.breakpoint.smAndDown) {
          if (newVal) {
            this.scrollTop = document.getElementsByTagName("body")[0].scrollTop || 
                            document.getElementsByTagName("html")[0].scrollTop || 
                            document.getElementById("app").scrollTop

            setTimeout(() => {
              disableDocumentScrolling(this.scrollTop)
            }, 300)
          } else {
            enableDocumentScrolling(this.scrollTop)
            this.scrollTop = null
          }
        }
      }
    },

    methods: {
      reloadPage() {
        window.location.reload();
      },
      ...mapMutations(['setLoginDialog']),
      closeDrawer() {
        this.drawer = false;
      },
      goToStaticLink(path) {
        window.location.href = path;
      },
      
      openLogin() {
        this.setLoginDialog(true)
      },
      
      toggleCart() {
        this.cartDialog = !this.cartDialog
      },
      
    goToGuestHistory() {
        const { query } = this.$route
        const mid = (this.getMenu && this.getMenu.code) ? this.getMenu.code : undefined;
        const route = {
          name: 'guest-history',
          params: {
            sid: this.getStore.storeId,
            gid: this.getStore.groupId
          },
          query: { ...query }
        };
        if (mid) route.params.mid = mid;
        this.$router.push(route).catch(() => {})
      },
    }
  }
</script>

<style scoped>
#headerBar {
  width: 100%;
}

.custom-header-toolbar {
  background-color: #FFFFFF !important;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  padding-left: 20px !important;
  padding-right: 20px !important;
  justify-content: flex-start !important;
  align-items: center !important;
}

.custom-header-toolbar.v-toolbar::v-deep .v-toolbar__content {
  min-height: 100px !important;
  height: auto !important;
  width: 100%;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.mobile-toolbar-header.v-toolbar {
  min-height: 40px !important;
  max-height: 54px !important;
  height: auto !important;
  background-color: #FFFFFF !important;
}

.mobile-toolbar-header.v-toolbar::v-deep .v-toolbar__content {
  min-height: 40px !important;
  max-height: 54px !important;
  height: auto !important;
  width: 100%;
  padding-left: 10px !important;
  padding-right: 0px !important;
}

/* Header Link Styles */
.header-links {
  display: flex;
  align-items: center;
}

.header-link.v-btn {
  font-size: 16px !important;
  background-color: transparent !important;
  box-shadow: none !important;
  transform: none !important;
  color: black;
  font-weight: bold;
  text-transform: uppercase;
  padding: 0 !important;
  min-width: unset !important;
  margin: 14px !important;
  border-radius: 0 !important;
  position: relative;
  overflow: visible !important;
  font-family: 'Montserrat', sans-serif !important;
}

/* Remove all hover effects except text color change */
.header-link.v-btn:hover,
.header-link.v-btn:focus,
.header-link.v-btn:active {
  background-color: transparent !important;
  color: var(--v-primary-base) !important;
  box-shadow: none !important;
  transform: none !important;
  border-color: transparent !important;
}

/* Only change the color of the text */
.header-link.v-btn:hover .v-btn__content,
.header-link.v-btn:focus .v-btn__content,
.header-link.v-btn:active .v-btn__content,
.header-link.v-btn:hover .v-icon,
.header-link.v-btn:focus .v-icon,
.header-link.v-btn:active .v-icon {
  color: var(--v-primary-base)!important;
}

/* Remove ripple effect */
.header-link.v-btn::before {
  display: none !important;
}

/* Locations Dropdown Menu */
.v-menu__content {
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08) !important;
  border-radius: 4px !important;
}
.locations-dropdown-list.v-list {
  padding: 0 !important;
  background-color: white !important;
  border-radius: 4px !important;
  margin-top: 50px !important;
  width: auto !important;
  max-width: 250px !important;
  display: block !important;
  position: relative !important;
  z-index: 1010 !important;
}

.locations-dropdown-list .v-list-item {
  display: block !important;
  width: 100% !important;
  min-height: unset !important;
  padding: 0 !important;
  cursor: pointer !important;
}

.locations-dropdown-list .locations-dropdown-item-title {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: black !important;
  line-height: 1.3 !important;
  text-align: left !important;
  text-transform: uppercase !important;
  display: block !important;
  padding: 14px 24px 14px 30px !important;
  white-space: normal !important;
  word-break: break-word !important;
  font-family: 'Montserrat', sans-serif !important;
  cursor: pointer !important;
  transition: color 0.2s ease !important;
}

.locations-dropdown-list .v-list-item:hover .locations-dropdown-item-title {
  color: var(--v-primary-base) !important;
}

.locations-dropdown-list .v-list-item:hover {
  background-color: transparent !important;
}

.locations-dropdown-list .v-list-item:hover .locations-dropdown-item-title {
  color: var(--v-primary-base)!important;
}

/* Mobile Navigation Drawer */
.external-apps-drawer {
  width: 100% !important;
  height: 100vh !important;
  position: fixed;
  z-index: 2000;
  margin-top: 0 !important;
  max-width: 100% !important;
}

.close-btn-left {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 2001;
  color: white !important;
}

/* Cart Dialog */
.rounded-card {
  border-radius: 8px !important;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: var(--v-primary-base);
  color: white;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.title-text {
  font-size: 1.25rem;
  font-weight: 500;
}

.close-btn {
  color: white !important;
}

.badge-text {
  color: white !important;
  font-size: 0.75em;
  font-weight: bold;
}

.mobile-list-item {
  margin-bottom: 8px;
}

.mobile-list-item .v-btn {
  justify-content: flex-start;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  height: 48px;
}

.mobile-list-item .item-text {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.mobile-list-item .v-btn:hover .item-text {
  color: var(--v-primary-base);
}

.locations-mobile-submenu {
  margin-left: 16px;
  margin-top: 4px;
}

.locations-mobile-submenu .v-list-item {
  margin-bottom: 4px;
}

.locations-mobile-submenu .item-text {
  font-size: 14px;
  font-weight: normal;
}

.mobile-drawer {
  z-index: 1000;
}

.drawer-header {
  display: flex;
  justify-content: flex-end; 
  padding-bottom: 0px;
}

.mobile-drawer-fullscreen {
  width: 300px !important; 
  max-width: 80% !important; 
}

.v-navigation-drawer .v-list {
  padding-top: 0; 
}

.v-navigation-drawer .v-list-item__title {
  font-size: 16px;
  font-weight: 500; 
  color: black;
  padding: 12px 16px;
  text-transform: uppercase;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;
}

.v-navigation-drawer .v-list-item:hover .v-list-item__title {
  color: var(--v-primary-base); 
}

.v-navigation-drawer .v-list-item {
  cursor: pointer;
}

.v-navigation-drawer .v-list-item:hover {
  cursor: pointer;
}

.v-navigation-drawer .menu-item-highlight {
  color: var(--v-primary-base) !important;
}

.v-navigation-drawer .submenu-item-title {
  font-size: 14px !important; 
  font-weight: normal !important;
  padding-left: 32px !important;
  text-transform: none !important; 
}

.v-navigation-drawer .v-list-group__header .v-list-item__action .v-icon {
  color: black !important;
}

.drawer-list {
  display: flex;
  flex-direction: column !important;
  width: 100%;
  padding-top: 60px;
  align-items: start;
  padding-left: 30px;
}

.drawer-list .v-list-item {
  width: 100%;
  display: block;
  min-height: 48px;
  padding: 8px 16px;
}

.v-list-group__items {
  display: flex;
  flex-direction: column;
}

.web-margin {
  margin-left: 40px !important;
}
.mobile-margin {
  margin-left: 0 !important;
}
.drawer-close-container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 8px 8px 16px 8px;
}

.drawer-close-btn {
  margin-left: auto;
}

.drawer-list {
  padding-top: 8px;
}

/* --- FORCE LOCATIONS GROUP HEADER TO STAY WHITE --- */
::v-deep .theme--light.v-list .v-list__group__header,
::v-deep .theme--light.v-list .v-list__group__header:hover,
::v-deep .theme--light.v-list .v-list__group__header:focus,
::v-deep .theme--light.v-list .v-list__group__header:active {
  background: white !important;
  background-color: white !important;
  transition: none !important;
  display: flex;
  justify-content: space-between !important;
}

::v-deep .v-list__group__items {
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
}
::v-deep .v-list__group__header__append-icon {
  padding: 0px !important;
}
.mobile-nav-group .v-list-group__header {
  background: white !important;
  padding-left: 16px !important;
  padding-right: 16px !important;
  font-weight: 500;
  font-size: 18px;
  justify-content: space-between !important;
}
.mobile-nav-subitem {
  width: 100% !important;
  font-size: 18px !important;
  padding: 14px !important;
  text-align: left !important;
  cursor: pointer;
}

.mobile-nav-subitem:hover {
  cursor: pointer;
}

.mobile-nav-subitem:hover .v-list-item__title {
  color: var(--v-primary-base) !important;
}
.mobile-nav-item {
  font-size: 18px !important;
  padding: 14px !important;
  width: 100%;
  max-height: 46px !important;
  text-align: left;
  cursor: pointer;
}

.mobile-nav-item:hover {
  cursor: pointer;
}

.mobile-nav-item:hover .v-list-item__title,
.mobile-nav-item:hover strong {
  color: var(--v-primary-base) !important;
}
.first-nav-item {
  font-size: 18px !important;
  padding-top: 0px !important;
  padding-left: 14px !important;
  padding-bottom: 10px !important;
  width: 100%;
  max-height: 46px !important;
  text-align: left;
}
.mobile-nav-group .v-list-group__header .v-icon {
  color: #333 !important;
}

.menu-item-highlight .v-list-item__title,
.menu-item-highlight strong {
  color: var(--v-primary-base) !important;
}
.menu-item-highlight,
.menu-item-highlight .v-btn__content {
  color: var(--v-primary-base) !important;
} 
</style>